// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_gi-b";
export var colorBlue = "_gi-8";
export var colorDot = "_gi-0";
export var colorDotLarge = "_gi-2";
export var colorDotSmall = "_gi-1";
export var colorGreen = "_gi-7";
export var colorGrey = "_gi-3";
export var colorOrange = "_gi-5";
export var colorPink = "_gi-a";
export var colorPurple = "_gi-9";
export var colorRed = "_gi-4";
export var colorYellow = "_gi-6";